<template>
  <div>
    <div class="page-title mb-5">
      <div class="container">
        <ul class="nav">
          <li class="nav-item border-left-0">
            <a class="nav-link" @click="goHome()">
              <img src="~../assets/image/icon/home.png" height="40" />
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">{{$t('history')}}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="container mb-3 pt-4 pb-4 bg-white">
      <div class="col-sm-12 text-right" v-if="false">
        <span class="btn btn-default">
          <img src="~../assets/image/icon/close_lesson.png" />
        </span>
      </div>

      <div class="col-sm-12">
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item ml-5">
            <a class="nav-link rounded-top active">{{$t('browsing_history')}}</a>
          </li>
        </ul>

        <ul class="list-group ml-5 mr-5">
          <li class="list-group-item d-flex justify-content-between mb-3 border-top-0 border-left-0 border-right-0"
            v-for="(lesson, index) in list" :key="index">
            <div class="d-flex align-items-center w-50">
              <b>{{ index < 9  ? '0' + (index + 1) : (index + 1) }}. {{ lesson.localName }} </b>
            </div>
            <div class="d-flex align-items-center ml-auto">
              {{$t('watch_time')}}：{{ lesson.spendTime }}
            </div>
            <div class="d-flex align-items-center ml-auto">
              {{$t('after-class_test')}}：{{ lesson.practiceScore }}
            </div>
            <div class="d-flex align-items-center ml-auto">
              {{$t('watch_date')}}：{{ lesson.lastTime }}
            </div>
            <div class="d-flex align-items-center ml-auto">
              <icon-button name="more_info" :alt="$t('start_the_course')" @click.native="$router.push({ name: 'lesson.player', params: { lessonId: lesson.id } })" />
            </div>
          </li>
        </ul>
      </div>

      <div class="col-4 offset-3" v-if="pageCount > 1">
        <pagination :current="pageIndex" :total="pageCount" v-on:page="getList" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../components/Pagination'
// import EmptyPage from './Teacher/EmptyPage'
import api from '../store/api'
import IconButton from './Teacher/IconButton'

export default {

  name: 'History',

  components: {
    Pagination,
    IconButton
  },

  data () {
    return {
      list: [],
      pageIndex: 1,
      pageCount: 0
    }
  },

  mounted () {
    this.getList()
  },

  methods: {
    async getList (page) {
      page = page || 1
      const { data } = await api.get('/Lesson/History', { params: { pageIndex: page } })

      if (data.status === 'OK') {
        this.list = data.data
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-link {
    color: #000;

    &.active {
      background-color: #c2c2c2!important;
      color: #fff!important;
    }
  }

  .rounded-top {
    border-top-left-radius: 0.75rem!important;
    border-top-right-radius: 0.75rem!important;
  }
</style>



// WEBPACK FOOTER //
// History.vue?4db37584